module.exports = __webpack_public_path__ + "./img-willy_716d3462388cc4e30a777af497ffbef6.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2016/img-willy.png
// module id = 433
// module chunks = 0